export default __webpack_public_path__ + "static/media/aws.02b06461.png";